import { GetApp } from '@mui/icons-material';
import { Button } from '@mui/material';
import { StyledPdfTooLargeMessage } from '../../styled/PdfDialog';

const PdfTooLargeMessage = ({
    onDownload,
}) => {
    return (
        <StyledPdfTooLargeMessage.Container>
            <StyledPdfTooLargeMessage.Title variant="h5">
                El archivo es muy grande para visualizar en el navegador
            </StyledPdfTooLargeMessage.Title>

            <StyledPdfTooLargeMessage.Recommendation>
                Por favor descargar el archivo.
            </StyledPdfTooLargeMessage.Recommendation>

            <StyledPdfTooLargeMessage.ButtonsContainer>
                <Button
                    variant="contained"
                    startIcon={<GetApp />}
                    onClick={onDownload}
                    color='primary'
                >
                    Descargar PDF
                </Button>
            </StyledPdfTooLargeMessage.ButtonsContainer>
        </StyledPdfTooLargeMessage.Container>
    );
};

export default PdfTooLargeMessage;